// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"o1-z","dimensionLabel":"p1-z","styleChooserControlWrapper":"q1-z","styleChooserControl":"r1-z","disabled":"s1-z","giftCard":"t1-z","styleChooserText":"u1-z"};